<template>
  <div class="center">
    <div class="center_bg">
      <a-row align="middle" type="flex">
        <a-col :xs="{ span: 5, offset: 1 }" :lg="{ span: 7, offset: 12 }">
          <div class="aa">
            <a-card title="" :bordered="false">
              <h1 class="name">八达管理系统</h1>
              <a-tabs default-active-key="2" @change="onChange">
                <a-tab-pane key="1" tab="后台登录">
                  <a-form-model
                    :rules="rules"
                    ref="formShopLogin"
                    layout="vertical"
                    :model="formInline"
                    @submit.native.prevent
                  >
                    <a-form-model-item has-feedback prop="user">
                      <a-input
                        v-model="formInline.user"
                        placeholder="请输入账号"
                        size="large"
                      >
                        <a-icon
                          slot="prefix"
                          type="user"
                          style="color: rgba(0, 0, 0, 0.25)"
                        />
                      </a-input>
                    </a-form-model-item>
                    <a-form-model-item has-feedback prop="password">
                      <a-input
                        v-model="formInline.password"
                        type="password"
                        placeholder="请输入登录密码"
                        size="large"
                      >
                        <a-icon
                          slot="prefix"
                          type="lock"
                          style="color: rgba(0, 0, 0, 0.25)"
                        />
                      </a-input>
                    </a-form-model-item>
                    <a-form-model-item>
                      <a-row>
                        <a-col :span="16">
                          <a-input
                            v-model="formInline.imgPass"
                            type="user"
                            placeholder="请输入图形验证码"
                            size="large"
                          >
                            <a-icon
                              slot="prefix"
                              type="lock"
                              style="color: rgba(0, 0, 0, 0.25)"
                            />
                          </a-input>
                        </a-col>
                        <a-col :span="7" :offset="1" @click="handleChangeimg('imgBoxShop')">
                          <img
                            class="verification-code"
                            ref="imgBoxShop"
                            src=""
                            alt=""
                            srcset=""
                          />
                        </a-col>
                      </a-row>
                    </a-form-model-item>
                    <!-- <a-form-item> </a-form-item> -->
                    <a-form-model-item>
                      <a-button
                        type="primary"
                        html-type="submit"
                        block
                        size="large"
                        @click="toHome()"
                      >
                        登录
                      </a-button>
                    </a-form-model-item>
                  </a-form-model>
                </a-tab-pane>
                <a-tab-pane key="2" tab="门店登录">
                  <a-form-model
                    :rules="rules"
                    layout="vertical"
                    :model="Store"
                    @submit.native.prevent
                  >
                    <a-form-model-item has-feedback prop="user">
                      <a-input
                        v-model="Store.user"
                        placeholder="请输入账号"
                        size="large"
                      >
                        <a-icon
                          slot="prefix"
                          type="user"
                          style="color: rgba(0, 0, 0, 0.25)"
                        />
                      </a-input>
                    </a-form-model-item>
                    <a-form-model-item has-feedback prop="password">
                      <a-input
                        v-model="Store.password"
                        type="password"
                        placeholder="请输入登录密码"
                        size="large"
                      >
                        <a-icon
                          slot="prefix"
                          type="lock"
                          style="color: rgba(0, 0, 0, 0.25)"
                        />
                      </a-input>
                    </a-form-model-item>
                    <a-form-model-item>
                      <a-row>
                        <a-col :span="16">
                          <a-input
                            v-model="Store.imgPass"
                            type="user"
                            placeholder="请输入图形验证码"
                            size="large"
                          >
                            <a-icon
                              slot="prefix"
                              type="lock"
                              style="color: rgba(0, 0, 0, 0.25)"
                            />
                          </a-input>
                        </a-col>
                        <a-col :span="7" :offset="1" @click="handleChangeimg('imgBoxStore')">
                          <img
                            class="verification-code"
                            ref="imgBoxStore"
                            src=""
                            alt=""
                            srcset=""
                          />
                        </a-col>
                      </a-row>
                    </a-form-model-item>
                    <a-form-item>
                      <a
                        class="login-form-forgot"
                        href="javascript:;"
                        @click="forget"
                      >
                        忘记密码
                      </a>
                    </a-form-item>
                    <a-modal v-model="visible" title="忘记密码" @ok="handleOk">
                      <p>Some contents...</p>
                      <p>Some contents...</p>
                      <p>Some contents...</p>
                    </a-modal>
                    <a-form-model-item>
                      <a-button
                        type="primary"
                        html-type="submit"
                        block
                        size="large"
                        @click="toHomeTwo()"
                      >
                        登录
                      </a-button>
                    </a-form-model-item>
                  </a-form-model>
                </a-tab-pane>
              </a-tabs>
            </a-card>
          </div>
        </a-col>
      </a-row>
      <a href="https://beian.miit.gov.cn">
        <h3 class="beian">粤ICP备16083823号</h3>
      </a>
    </div>
  </div>
</template>

<script>
import {Login, getImgCode} from "@/api/LoginApi.js";
import {storeLogin} from "@/api/storeApi.js";
import {getRouters} from "@/api/testApi.js";
import {message} from "ant-design-vue";

export default {
  data() {
    let validatePass = (rule, value, callback) => {
      // 6-16个字符，至少包含大小写字母和数字各一个
      let rule1 = /^(?=.*[a-z])(?=.*[A-Z])(?=.*\d)[^]{6,16}$/;
      if (value === "") {
        callback(new Error("请输入密码"));
      }/* else if (!rule1.test(value)) {
        callback(new Error("6-16个字符,至少包含大小写字母和数字各一个"));
      }*/
      callback();
    };
    let validateUser = (rule, value, callback) => {
      if (value === "") {
        console.log("触发了规则校验");
        callback(new Error("请输入账号名称"));
      }
      callback();
    };
    return {
      menuList: [],
      visible: false,
      formInline: {
        user: "",
        password: "",
        imgPass: "",
      },
      Store: {
        user: "",
        password: "",
        imgPass: "",
      },
      rules: {
        user: [{validator: validateUser, trigger: "change"}],
        password: [{validator: validatePass, trigger: "change"}],
      },
    };
  },
  beforeCreate() {
    // this.form = this.$form.createForm(this, { name: "normal_login" });
  },
  mounted() {
    this.handleChangeimg('imgBoxStore');
  },
  methods: {
    aa() {
      console.log("asdas");
    },
    onChange(res) {
      this.$nextTick(() => {
        this.handleChangeimg(res == 1 ? 'imgBoxShop' : 'imgBoxStore');
      })
      this.$forceUpdate();
    },
    // handleSubmit(e) {
    //   e.preventDefault();
    //   this.form.validateFields((err, values) => {
    //     if (!err) {
    //       console.log("Received values of form: ", values);
    //     }
    //   });
    // },

    openNotification() {
      this.$notification.open({
        message: "温馨提醒",
        description: "账号和密码不能为空哦！",
        icon: <a-icon type="smile" style="color: #108ee9"/>,
      });
    },
    // 忘记密码
    forget() {
      this.visible = true;
    },
    handleOk() {
      this.visible = false;
    },
    async toHome() {
      if (
        this.formInline.user.trim() === "" ||
        this.formInline.password.trim() === ""
      ) {
        this.openNotification();
      } else {
        this.loading=true;
        // this.$router.push('home')
        let data = {
          loginNo: this.formInline.user,
          loginPwd: this.$md5(this.formInline.password),
          code: this.formInline.imgPass,
          projectToken: "18111501",
        };
        let result = await Login(data).then((res) => {
          this.loading=false;
          // console.log(res.data.menuBoList[0], "menuBoList");
          if (res.code === "0000") {
            message.success("登录成功");
            sessionStorage.setItem("user_token", res.data.token);
            sessionStorage.setItem(
              "menudata",
              JSON.stringify(res.data.menuBoList)
            );
            sessionStorage.setItem("shopId", res.data.shopId);
            sessionStorage.setItem("hedImg", res.data.headImg);
            sessionStorage.setItem("name", res.data.name);
            this.$router.push("/home/homeContent");
          } else {
            message.error(res.info);
            // 更新验证码
            this.handleChangeimg('imgBoxShop');
          }
        }).catch(err => {
          this.loading=false;
          message.error(err.info);
          // 登录失败更新验证码
          this.handleChangeimg('imgBoxShop');
        });
    
        // console.log(res, "登录成功， 回到首页");
      }
    },
    async toHomeTwo() {
      if (this.Store.user.trim() === "" || this.Store.password.trim() === "") {
        this.openNotification();
      } else {
        this.loading=true;
        // this.$router.push('home')
        let data = {
          loginNo: this.Store.user,
          loginPwd: this.$md5(this.Store.password),
          code: this.Store.imgPass,
          projectToken: "18111501",
        };
        let result = await storeLogin(data).then((res) => {
          this.loading=false;
          if (res.code === "0000") {
            sessionStorage.setItem("user_token", res.data.token);
            sessionStorage.setItem(
              "menudata",
              JSON.stringify(res.data.menuBoList)
            );
            sessionStorage.setItem("shopId", res.data.shopId);
            sessionStorage.setItem("shopName", res.data.shopName);
            sessionStorage.setItem("hedImg", res.data.headImg);
            sessionStorage.setItem("roleName", res.data.roleName);
            sessionStorage.setItem("partnerId", res.data.partnerId ? true : false);
            this.$router.push("/home/homeContentTwo");
          } else if (res.code === "9999") {
            this.loading=false;
            message.error(res.info);
            // 更新验证码
            this.handleChangeimg('imgBoxStore');
          }
        });
      }
    },
    async handleChangeimg(refDom) {
      // const server_url = process.env.TARGET_URL;
      // server_url +
      // 防止在不同域名下, 请求到的是固定的域名
      const code_url = "bada/cityAdmin/admin/open/code?";
      this.$refs[refDom].src = code_url + new Date().getTime();
      console.log("点击了切换图片验证码");
    },
  },
};
</script>

<style lang="scss" scoped="" type="text/css">
.center {
  // background-image: url(../../assets/bg.jpeg);
  .center_bg {
    position: fixed;
    top: 0;
    left: 0;
    width: 100%;
    height: 100%;
    min-width: 1000px;
    z-index: 1;
    zoom: 1;
    background-color: #fff;
    background: url(../../assets/bg.jpeg) no-repeat;
    background-size: cover;
    -webkit-background-size: cover;
    -o-background-size: cover;
    background-position: center 0;
    display: flex;
    flex-direction: column;
    justify-content: center;

    .name {
      text-align: center;
    }

    .verification-code {
      height: 40px;
      width: 100%;
    }
  }

  #components-form-demo-normal-login .login-form {
    max-width: 300px;
  }

  #components-form-demo-normal-login .login-form-forgot {
    float: right;
  }

  #components-form-demo-normal-login .login-form-button {
    width: 100%;
  }
}

h3 {
  width: 200px;
  position: relative;
  left: 600px;
  top: 150px;
  color: #fff;
  text-align: center;
}
</style>



// WEBPACK FOOTER //
// src/views/login/login.vue